var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hinava_random_uuid_111301738644949458548751948909791211680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5C7.43956 0.5 0.5 7.43956 0.5 16C0.5 24.5604 7.43956 31.5 16 31.5C24.5604 31.5 31.5 24.5604 31.5 16C31.5 7.43956 24.5604 0.5 16 0.5ZM16 3.5C22.9082 3.5 28.5 9.09069 28.5 16C28.5 22.9082 22.9093 28.5 16 28.5C9.09175 28.5 3.5 22.9093 3.5 16C3.5 9.09175 9.09069 3.5 16 3.5ZM24.7628 11.6417L23.3542 10.2218C23.0626 9.92775 22.5877 9.92581 22.2936 10.2176L13.4591 18.9811L9.72213 15.2137C9.43044 14.9197 8.95556 14.9177 8.6615 15.2094L7.24156 16.6179C6.9475 16.9096 6.94556 17.3845 7.23731 17.6786L12.9111 23.3984C13.2028 23.6924 13.6777 23.6944 13.9718 23.4026L24.7586 12.7024C25.0526 12.4106 25.0544 11.9358 24.7628 11.6417Z",
    fill: "url(#hinava_random_uuid_172675402256309189495098907704034216093)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_172675402256309189495098907704034216093",
    x1: 16,
    y1: 0.5,
    x2: 16,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hinava_random_uuid_111301738644949458548751948909791211680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.2f203f6772be958e7e46205e9c82fcdc.svg";
export { ForwardRef as ReactComponent };